import { IconName } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { classNames } from "primereact";
import { getIconType } from "./icons";
import { IconType } from "./types";

type IconCardProps = {
  iconName: string;
  onClick: () => void;
  selected?: boolean;
};

const IconCard: React.FC<IconCardProps> = (props) => {
  const iconType = getIconType(props.iconName);

  return (
    <div
      key={props.iconName}
      onClick={props.onClick}
      className={classNames("iconCard", {
        selected: props.selected,
      })}
    >
      <div className="iconCardIcon">
        {iconType === IconType.PrimeIcon ? (
          <div className={props.iconName} />
        ) : (
          <FontAwesomeIcon className="icon" icon={props.iconName as IconName} />
        )}
      </div>
    </div>
  );
};

export default IconCard;
